import { render, staticRenderFns } from "./po-view.vue?vue&type=template&id=31f56988&scoped=true&"
import script from "./po-view.vue?vue&type=script&lang=js&"
export * from "./po-view.vue?vue&type=script&lang=js&"
import style0 from "./po-view.vue?vue&type=style&index=0&id=31f56988&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f56988",
  null
  
)

export default component.exports